import { format } from "date-fns";

export function formatTimeLeft(timeLeft: any) {
  const formattedMonths =
    timeLeft.months > 0 ? `${timeLeft.months} months ` : "";

  const formattedDays = timeLeft.days > 0 ? `${timeLeft.days}d ` : "";

  const formattedHours = format(
    new Date(0, 0, 0, timeLeft.hours, timeLeft.minutes, timeLeft.seconds),
    "HH:mm:ss",
  );

  return `${formattedMonths}${formattedDays}${formattedHours}`;
}
